import { useEffect, useRef, useState } from "react";
import {
  LiaHornbill,
  LiaSearchPlusSolid,
  LiaSearchSolid,
} from "react-icons/lia";
import { MdClose, MdEdit, MdPrint } from "react-icons/md";
import { packingEntryAPI } from "../../utlis/apiService";
import { notify } from "../../common/Toast";
import Loader from "../../common/Loader";
import Table from "../../common/Table";
import Pagination from "../../common/Pagination";
import ConfirmDeleteModal from "../../common/DeleteModel";
import ErrorModal from "../../common/CustomModel";
import { HiOutlinePlus } from "react-icons/hi";
import PackingForm from "./PackingForm";

import { IoCloseSharp } from "react-icons/io5";
import { IoIosSave } from "react-icons/io";
import { LayoutGrid } from "lucide-react";
import { RiHistoryLine } from "react-icons/ri";
import { RegistryHeader, Button, CalculationFooter } from "../../common/Shared";

const Packing = () => {
  const today = new Date().toISOString()?.split("T")[0];
  const [searchQuery, setSearchQuery] = useState("");
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorSubMessage, setErrorSubMessage] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [selectedPackingData, setSelectedPackingData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isPackingData, setisPackingData] = useState([]);
  const [isAgingDoneData, setIsAgingDoneData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [formData, setFormData] = useState({
    bundle_No: null,
    packing_Date: today,
    order_No: "",
    batch_Id: "",
    die_Id: "",
    casting_No: "",
    dieNumber: "",
    cut_Length: "",
    wt_12_FT: "",
    wt_Cut_Length: "",
    pcs: "",
    total_Weight: "",
    series_Name: "",
    remark: "",
    // bundle_Pcs: "",
    // bundle_Weight: "",
    unit_Conv_Id: "",
    final_CutLength_weight: "",
  });
  const pageSize = 10;
  const [isActiveTab, setIsActiveTab] = useState("aging-done");
  const [selectedAgingNo, setSelectedAgingNo] = useState([]);
  const [adding, setAdding] = useState(false);
  const [editingKey, setEditingKey] = useState(null);
  const [draft, setDraft] = useState({ pcs: "", total_Weight: "" });
  const [editingRow, setEditingRow] = useState(null);
  const [selectedBundles, setSelectedBundles] = useState([]);
  const tableScrollRef = useRef(null);
  const isFetchingRef = useRef(false);
  const [packingHasMore, setPackingHasMore] = useState(true);
  const [agingHasMore, setAgingHasMore] = useState(true);
  const [packingPage, setPackingPage] = useState(1);
  const [agingPage, setAgingPage] = useState(1);

  const fetchPackingData = async (page) => {
    setLoading(true);
    try {
      const res = await packingEntryAPI.getAllPackingEntry(page, pageSize);
      setisPackingData((prev) => {
        return page === 1 ? res.data || [] : [...prev, ...(res.data || [])];
      });

      if (!res.data || res.data.length < pageSize) {
        setPackingHasMore(false);
      }
      isFetchingRef.current = false;
    } catch (error) {
      notify("Error fetching sales order master data", "error");
    }
    setLoading(false);
  };

  useEffect(() => {
    if (searchQuery.trim() === "") {
      setFilteredData(isPackingData);
    } else {
      const filtered = isPackingData.filter((d) =>
        d.status_Name.toLowerCase().includes(searchQuery.toLowerCase()),
      );
      setFilteredData(filtered);
    }
  }, [searchQuery, isPackingData]);

  const handleEdit = async (row) => {
    const bundle_No = row?.bundle_No;
    setEditingKey(bundle_No);
    setDraft({
      pcs: row.pcs ?? "",
      total_Weight: row.total_Weight ?? "",
    });
    try {
      const res = await packingEntryAPI.getById(bundle_No);
      const doc = res?.data ?? res;
      setEditingRow(doc);
    } catch (err) {
      notify("Failed to fetch packing entry details", "error");
    }
  };

  const cancelInlineEdit = () => {
    setEditingKey(null);
    setDraft({ pcs: "", total_Weight: "" });
    setEditingRow(null);
  };

  const buildPayload = () => {
    const src = editingRow ?? {};
    return {
      ...src,
      bundle_No: src.bundle_No,
      order_No: src.order_No,
      die_Id: src.die_Id,
      cut_Length: src.cut_Length,
      packing_Date: src.packing_Date,
      batch_Id: src.batch_Id,
      casting_No: src.casting_No,
      series_Name: src.series_Name,
      remark: src.remark,
      wt_12_FT: src.wT_12_FT ?? src.wt_12_FT ?? 0,
      wt_Cut_Length: src.wT_Cut_Length ?? src.wt_Cut_Length ?? 0,
      // bundle_Pcs: src.bundle_Pcs ?? null,
      // bundle_Weight: src.bundle_Weight ?? null,
      unit_Conv_Id: src.unit_Conv_Id,
      final_CutLength_weight: src.final_CutLength_weight,
      pcs: Number(draft.pcs || 0),
      total_Weight: parseFloat(draft.total_Weight || 0),
    };
  };

  const handleinlineSave = async (row) => {
    setIsSaving(true);
    try {
      const payload = buildPayload();
      await packingEntryAPI.saveOrUpdate(payload);
      notify("Saved successfully", "success");
      cancelInlineEdit();
      fetchPackingData();
      setIsModelOpen(false);
    } catch (err) {
      notify(err?.response?.data?.message || "Failed to save", "error");
    } finally {
      setIsSaving(false);
    }
  };

  const handleSave = async (data, id) => {
    setIsSaving(true);
    try {
      const finalData = {
        bundle_No: data.bundle_No || "0",
        packing_Date: data.packing_Date,
        die_Id: data.die_Id,
        order_No: Number(data.order_No),
        dieNumber: data.dieNumber,
        batch_Id: data.batch_Id,
        casting_No: data.casting_No,
        cut_Length: Number(data.cut_Length),
        wt_12_FT: parseFloat(data.wt_12_FT || 0),
        wt_Cut_Length: parseFloat(data.wt_Cut_Length || 0),
        pcs: Number(data.pcs || 0),
        total_Weight: parseFloat(data.total_Weight || 0),
        series_Name: data.series_Name,
        remark: data.remark,
        // bundle_Pcs: data.bundle_Pcs,
        // bundle_Weight: data.bundle_Weight,
        unit_Conv_Id: data.unit_Conv_Id,
        final_CutLength_weight: data.final_CutLength_weight,
      };

      await packingEntryAPI.saveOrUpdate(finalData);
      notify(id ? "Updated successfully" : "Added successfully", "success");
      fetchPackingData();
      fetchAgingDoneData();
      setIsModelOpen(false);
      setFormData({
        bundle_No: "0",
        packing_Date: today,
        order_No: "",
        dieNumber: "",
        die_Id: "",
        batch_Id: "",
        casting_No: "",
        cut_Length: "",
        wt_12_FT: "",
        wt_Cut_Length: "",
        pcs: "",
        total_Weight: "",
        series_Name: "",
        remark: "",
        // bundle_Pcs: "",
        // bundle_Weight: "",
        unit_Conv_Id: "",
        final_CutLength_weight: "",
      });
      setIsEditing(false);
    } catch (error) {
      notify("Failed to submit form", "error");
      setErrorMessage("Submission failed");
      setErrorSubMessage("Please check your input or try again.");
      setErrorModalOpen(true);
    } finally {
      setIsSaving(false);
    }
  };

  const fetchAgingDoneData = async (page) => {
    setLoading(true);
    try {
      const res = await packingEntryAPI.getAllAgingDone(page, pageSize);
      setIsAgingDoneData((prev) => {
        return page === 1 ? res.data || [] : [...prev, ...(res.data || [])];
      });

      if (!res.data || res.data.length < pageSize) {
        setAgingHasMore(false);
      }
      isFetchingRef.current = false;
    } catch (error) {
      notify("Error fetching location data", "error");
    }
    setLoading(false);
  };

  const handleTabChange = (tab) => {
    setIsActiveTab(tab);
    if (tab === "aging-done") {
      setPackingPage(1);
      setIsAgingDoneData([]);
      setAgingHasMore(true);
    } else {
      setPackingPage(1);
      setisPackingData([]);
      setPackingHasMore(true);
    }
  };

  useEffect(() => {
    if (isActiveTab === "aging-done") fetchAgingDoneData(agingPage);
  }, [agingPage, isActiveTab]);

  useEffect(() => {
    if (isActiveTab === "packing") fetchPackingData(packingPage);
  }, [packingPage, isActiveTab]);

  useEffect(() => {
    const el = tableScrollRef.current;
    if (!el) return;

    const onScroll = () => {
      if (loading || isFetchingRef.current) return;

      const { scrollTop, clientHeight, scrollHeight } = el;

      if (scrollHeight - scrollTop <= clientHeight + 100) {
        isFetchingRef.current = true;

        if (isActiveTab === "aging-done" && agingHasMore) {
          setAgingPage((p) => p + 1);
        }

        if (isActiveTab === "packing" && packingHasMore) {
          setPackingPage((p) => p + 1);
        }
      }
    };

    el.addEventListener("scroll", onScroll);
    return () => el.removeEventListener("scroll", onScroll);
  }, [isActiveTab, loading, packingHasMore, agingHasMore]);

  const columns = [
    {
      key: "select",
      label: null,
      render: (_v, row) => {
        const id = Number(row.seq_No);
        const isChecked = selectedAgingNo.includes(id);
        return (
          <input
            type="checkbox"
            checked={isChecked}
            onChange={(e) => {
              if (e.target.checked) {
                setSelectedAgingNo((prev) => [...prev, id]);
              } else {
                setSelectedAgingNo((prev) =>
                  prev.filter((item) => item !== id),
                );
              }
            }}
          />
        );
      },
    },
    { key: "order_No", label: "ORDER NO" },
    { key: "batch_Id", label: "BATCH NO" },
    { key: "dieNumber", label: "DIE NO" },
    { key: "cut_Length", label: "CUT LENGTH" },
    { key: "quantity", label: "PCS" },
    { key: "pending_Pcs", label: "PENDING PCS" },
    { key: "total_Weight", label: "TOTAL WEIGHT" },
  ];

  const handleAddPacking = async () => {
    if (!selectedAgingNo) {
      notify("Please select one Aging-Done row.", "warning");
      return;
    }
    setAdding(true);
    try {
      const resp = await packingEntryAPI.AddToPacking(
        Number(selectedAgingNo[0]),
      );
      const x = Array.isArray(resp) ? resp[0] : resp;
      const init = {
        bundle_No: "0",
        packing_Date: today,
        order_No: x?.order_No ?? "",
        die_Id: x?.die_Id ?? null,
        dieNumber: x?.dieNumber ?? "",
        cut_Length: x?.cut_Length ?? "",
        batch_Id: x?.batch_Id ?? "",
        casting_No: x?.casting_No ?? "",
        total_Weight: x?.total_Weight ?? "",
        wt_12_FT: "",
        wt_Cut_Length: "",
        pcs: "",
        series_Name: x?.series_Name ?? "",
        remark: "",
        // bundle_Pcs: "",
        // bundle_Weight: "",
        unit_Conv_Id: "",
        final_CutLength_weight: "",
      };
      setSelectedPackingData(init);
      setIsActiveTab("packing");
      setIsModelOpen(true);
      setIsEditing(true);
      setSelectedAgingNo([]);
    } catch (e) {
      notify(
        e?.response?.data?.message || e?.message || "Failed to Add to Packing",
        "error",
      );
    } finally {
      setAdding(false);
    }
  };

  const handlePrint = async () => {
    if (selectedBundles.length === 0) {
      notify("Please select at least one bundle to print", "warning");
      return;
    }

    try {
      const payload = { bundleNos: selectedBundles };
      const res = await packingEntryAPI.packingBundles(payload);

      const blob = new Blob([res.data], { type: "application/pdf" });

      const pdfUrl = URL.createObjectURL(blob);
      window.open(pdfUrl, "_blank");
    } catch (error) {
      notify("Failed to print selected bundles", "error");
    }
  };

  const renderCell = (
    row,
    field,
    { type = "text", step, align = "right", editingKey, draft, setDraft } = {},
  ) => {
    const editable = editingKey === row.bundle_No;
    const value = editable ? (draft[field] ?? "") : (row[field] ?? "");

    if (editable) {
      return (
        <input
          type={type}
          step={step}
          value={value}
          onChange={(e) => setDraft((d) => ({ ...d, [field]: e.target.value }))}
          className={`w-full bg-white border border-blue-400 rounded px-1.5 py-1 outline-none focus:ring-1 focus:ring-blue-500 text-[12px]  text-${align}`}
        />
      );
    }

    return (
      <span className={`block px-2 py-1 font-medium text-${align}`}>
        {value || value === 0 ? value : "-"}
      </span>
    );
  };

  return (
    <div className="flex flex-col h-full bg-white font-plus">
      <RegistryHeader title="Packing Plan View">
        <div className="flex bg-gray-100 p-1 rounded-sm gap-1 shrink-0">
          <button
            onClick={() => handleTabChange("aging-done")}
            className={`px-6 py-2 text-[10px] font-black uppercase tracking-widest transition-all ${isActiveTab === "aging-done"
              ? "bg-[#3F80F7] text-white  #3F80F7]/20"
              : "text-gray-400 hover:text-gray-600 hover:bg-gray-200/50"
              }`}
          >
            Aging Done
          </button>
          <button
            onClick={() => handleTabChange("packing")}
            className={`px-6 py-2 text-[10px] font-black uppercase tracking-widest transition-all ${isActiveTab === "packing"
              ? "bg-[#3F80F7] text-white  #3F80F7]/20"
              : "text-gray-400 hover:text-gray-600 hover:bg-gray-200/50"
              }`}
          >
            Packing Entry
          </button>
        </div>

        <div className="relative w-full sm:w-80 group">
          <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none group-focus-within:text-[#3F80F7]">
            <LiaSearchSolid size={18} className="text-gray-400 transition-colors" />
          </div>
          <input
            type="text"
            className="block w-full pl-12 pr-10 py-2.5 bg-gray-50 border border-gray-200 text-gray-900 text-[11px] font-black uppercase tracking-[2px] focus:border-[#3F80F7] focus:bg-white focus:outline-none transition-all placeholder:text-gray-300"
            placeholder={
              isActiveTab === "aging-done"
                ? "Search by order, customer..."
                : "Search packing details..."
            }
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          {searchQuery && (
            <button
              onClick={() => setSearchQuery("")}
              className="absolute inset-y-0 right-0 pr-4 flex items-center text-gray-400 hover:text-red-500 transition-colors"
            >
              <MdClose size={18} />
            </button>
          )}
        </div>

        {isActiveTab === "aging-done" ? (
          <Button
            disabled={adding || selectedAgingNo.length === 0}
            onClick={handleAddPacking}
            icon={HiOutlinePlus}
            className={`w-full md:w-auto flex items-center justify-center gap-2 px-6 py-2.5 rounded-xl font-bold text-sm transition-all duration-300 ${
              selectedAgingNo?.length > 0
                ? "bg-orange text-white shadow-lg shadow-orange hover:bg-orange-600 hover:-translate-y-0.5 active:scale-95 cursor-pointer"
                : "bg-slate-100 text-slate-400 cursor-not-allowed"
            }`}
          >
            {adding ? "INITIALIZING..." : `Add Packing (${selectedAgingNo.length})`}
          </Button>
        ) : (
          <button
            onClick={handlePrint}
            disabled={selectedBundles.length === 0}
            className={`h-[42px] px-8 text-[10px] font-black uppercase tracking-[3px] transition-all flex items-center gap-3 border ${selectedBundles.length > 0
              ? "bg-gray-900 text-white border-gray-900 hover:bg-black font-black"
              : "bg-gray-100 text-gray-400 border-gray-200 cursor-not-allowed font-black"
              }`}
          >
            <MdPrint size={16} className={selectedBundles.length > 0 ? "text-[#3F80F7]" : "text-gray-300"} /> Print Sticker({selectedBundles.length})
          </button>
        )}
      </RegistryHeader>

      <div className="px-8 pt-0 pb-4 flex-1 overflow-hidden flex flex-col bg-white">
        <div
          ref={tableScrollRef}
          className="relative flex-1 overflow-auto border border-gray-200 bg-white"
        >
          {loading && <Loader centered />}
          {isActiveTab === "aging-done" && (
            <div className="min-w-max">
              <Table
                columns={columns}
                data={isAgingDoneData}
                showActions={false}
                onRowClick={(row) => setSelectedAgingNo(Number(row.seq_No))}
                tableClassName="text-[13px]"
              />
            </div>
          )}
          {isActiveTab === "packing" && (
            <div className="min-w-max bg-white">
              <Table
                columns={[
                  {
                    key: "select", label: "✓", align: "center", className: "w-12 border-r border-gray-100",
                    render: (val, row) => (
                      <input
                        type="checkbox"
                        checked={selectedBundles.includes(row.bundle_No)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedBundles((prev) => [...prev, row.bundle_No]);
                          } else {
                            setSelectedBundles((prev) => prev.filter((id) => id !== row.bundle_No));
                          }
                        }}
                        className="w-4 h-4 text-[#3F80F7]"
                      />
                    )
                  },
                  { key: "bundle_No", label: "BUNDLE NO", align: "center", className: "font-black text-gray-900 border-r border-gray-100" },
                  { key: "dieNumber", label: "DIE NO", align: "left", className: "font-black text-[#3F80F7] border-r border-gray-100" },
                  { key: "series_Name", label: "SERIES", align: "left", className: "border-r border-gray-100 font-black text-gray-800 text-[11px] uppercase tracking-wider" },
                  { key: "profile_Name", label: "PROFILE", align: "left", className: "border-r border-gray-100 text-[10px] text-gray-400 font-medium uppercase" },
                  { key: "wt_Cut_Length", label: "FINAL CUT LENGHT", align: "right", className: "text-gray-600 border-r border-gray-100 font-mono tracking-tighter", render: (val, row) => row.wt_Cut_Length || row.wT_Cut_Length },
                  { key: "unit_Conv_Name", label: "UNIT", align: "center", className: "text-gray-500 border-r border-gray-100 font-black text-[11px] uppercase tracking-widest" },
                  { key: "wt_12_FT", label: "WT/12 FT", align: "right", className: "text-gray-600 border-r border-gray-100 font-mono tracking-tighter", render: (val, row) => row.wt_12_FT || row.wT_12_FT },
                  { key: "final_CutLength_weight", label: "FINAL CUT LENGTH WT", align: "right", className: "text-gray-600 border-r border-gray-100 font-mono tracking-tighter" },
                  {
                    key: "pcs", label: "PCS", align: "right", className: "border-r border-gray-100 w-28",
                    render: (val, row) => renderCell(row, "pcs", { align: "right", type: "number", step: "1", editingKey, draft, setDraft })
                  },
                  {
                    key: "total_Weight", label: "TOTAL WT", align: "right", className: "border-r border-gray-100 w-28",
                    render: (val, row) => renderCell(row, "total_Weight", { align: "right", type: "number", step: "0.001", editingKey, draft, setDraft })
                  },
                  {
                    key: "actions", label: "ACTIONS", align: "center",
                    render: (val, row) => {
                      const isEditingRow = editingKey === row.bundle_No;
                      return (
                        !isEditingRow ? (
                          <button
                            className="group p-2 text-gray-300 hover:text-[#3F80F7] transition-all"
                            onClick={() => handleEdit(row)}
                            disabled={!!editingKey && editingKey !== row.bundle_No}
                          >
                            <MdEdit size={18} />
                          </button>
                        ) : (
                          <div className="flex justify-center gap-2">
                            <button
                              className="px-4 py-1.5 bg-[#3F80F7] text-white font-black text-[10px] uppercase tracking-widest transition-all hover:bg-[#2c5ebc]"
                              onClick={() => handleinlineSave()}
                              disabled={isSaving}
                            >
                              Save
                            </button>
                            <button
                              className="p-1.5 bg-white border border-gray-200 text-gray-400 hover:text-red-500 transition-all"
                              onClick={cancelInlineEdit}
                              disabled={isSaving}
                            >
                              <MdClose size={14} />
                            </button>
                          </div>
                        )
                      );
                    }
                  }
                ]}
                data={isPackingData}
                showActions={false}
                tableClassName="text-[13px] border-none"
              />
            </div>
          )}
        </div>
      </div>

      {isModelOpen && formData && (
        <PackingForm
          initialData={selectedPackingData}
          onSave={handleSave}
          onCancel={() => setIsModelOpen(false)}
          isEditing={isEditing}
          filteredData={filteredData}
          formData={formData}
          setFormData={setFormData}
          isSaving={isSaving}
        />
      )}

      {errorModalOpen && (
        <ErrorModal
          message={errorMessage}
          subMessage={errorSubMessage}
          onClose={() => setErrorModalOpen(false)}
        />
      )}

      <CalculationFooter
        items={[
          {
            label: "Total Units",
            value: isPackingData.reduce((sum, row) => sum + (Number(row.pcs) || 0), 0).toLocaleString(),
            suffix: "PCS"
          },
          {
            label: "Gross Weight",
            value: isPackingData.reduce((sum, row) => sum + (Number(row.total_Weight) || 0), 0).toFixed(3),
            suffix: "KG",
            color: "text-[#3F80F7]"
          }
        ]}
      />
    </div>

  );
};

export default Packing;
